<template>
  <div>
    <el-autocomplete
     style="width:100%;"
      v-model="contact"
      :fetch-suggestions="remoteMethod"
      placeholder="Saisir des mots-clés"
      :trigger-on-focus="false"
      @select="handleSelect"
    >
    <template slot-scope="{ item }">
      <span>{{contactName(item)}}</span><br>
      <div style="margin-bottom:5px;margin-left:5px;padding-left:5px;line-height:25px;" class="border-left">
        <span class="secondary-text fs-14"><i class="el-icon-message" style="margin-right:5px;"/>{{item.email}}</span>
        <span class="secondary-text fs-14" v-if="item.phone!=null && item.phone!==''"><br><i class="el-icon-phone" style="margin-right:5px;"/> {{formattedPhone(item.phone)}}</span>
        <div v-for="(cie, index) in item.companies" :key="index">
          <span class="secondary-text fs-14">
            <span v-if="cie.role!=null">{{cie.role}}@</span>{{cie.company_name}}</span>
        </div>
      </div>
    </template></el-autocomplete>
  </div>
</template>
<script>
import axios from "axios"
import ContactAPI from '@/services/API/contact'
import { AsYouType } from 'libphonenumber-js'

export default {
	name: 'ContactPicker',
  props: {
	},
	data() {
		return {
      contact : null,
      loading : false,
      searchContacts : [],
	   }
   },
   components : {

   },
   methods : {
     remoteMethod(query, cb){
       return ContactAPI.fetchContacts({searchTerms:query,paging:'no'})
        .then(searchContacts=>{
          cb(searchContacts);
        })
     },
     handleSelect(contact){
       this.$emit('select',contact);
     },
     contactName(contact){
       if((contact.first_name==null || contact.first_name==='') && (contact.last_name==null || contact.last_name==='')){
         return 'Unnamed contact';
       }else{
         return contact.first_name + ' ' + contact.last_name;
       }
     },
     formattedPhone(phone){
       if(phone!=null && phone!==''){
         return new AsYouType('CA').input(phone)
       }else{
        return null
       }
     },
     getCompanies(companies){
       let str = null;
       _.forEach(companies, (cie, index)=>{
         if(str==null)str='';
         if(cie.role!=null){
           str+=cie.role+'@'+cie.usual_name;
         }else{
           str+=cie.role+'@'+cie.usual_name;
         }
         if(index<companies.length) str+=", ";
       })
       return str;
     }
   },
   computed: {


   }

}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

</style>
